import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Company & Contact Tracking",
  published_at: "2026-01-12",
  summary: "Track the companies and contacts behind every opportunity with built-in CRM capabilities.",
  tags: ["Platform"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    img: "img",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Sweetspot now includes full company and contact tracking, so you can manage your relationships right alongside your opportunities and pursuits. Create company profiles with UEI, CAGE codes, and relationship types. Add contacts with their roles, email, phone, and even upload resumes. Every interaction — calls, emails, meetings, notes — is logged in a timeline so your whole team stays informed."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/changelog/2026-01-12-company-tracking/company-overview-2026-03-03.png",
        alt: "Company overview with relationship details"
      })
    }), "\n", _jsx(_components.p, {
      children: "You can track relationship status at a glance, see which companies are connected to which opportunities, and build a complete picture of your teaming landscape. The AI assistant can automatically extract company and contact information from uploaded documents, saving you hours of manual data entry. Need to bring in existing records? Bulk import from spreadsheets, and if duplicates slip in, merge them with a few clicks."
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "AI (1)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Improved knowledge base reliability when working with large document libraries"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Compliance (2)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Color-coded status indicators on compliance checklist items"
        }), "\n", _jsx(_components.li, {
          children: "Fixed compliance checklist sometimes showing incomplete results"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "General (2)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Faster page load times across the platform"
        }), "\n", _jsx(_components.li, {
          children: "Fixed an error that could occur when creating a new organization"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
